var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E74444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z",
    fill: "#E74444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconCircle);
export default __webpack_public_path__ + "static/media/closeIconCircle.75a6a6389ef3b983589f487c75bd5a97.svg";
export { ForwardRef as ReactComponent };